import KEYS from '../../constants/keys.constants';
import {TreeConfig} from './jf_component_tree.config';

const JSTREE_ROW_HOVER_CLASS = 'jstree-hovered';

const PACKAGES_ICONS = {
    maven: {
        icon: "icon icon-pom"
    },
    docker: {
        icon: "icon icon-docker"
    },
    nuget: {
        icon: "icon icon-nuget"
    },
    npm: {
        icon: "icon icon-npm"
    },
    bower: {
        icon: "icon icon-bower"
    },
    pypi: {
        icon: "icon icon-pypi"
    },
    rubygems: {
        icon: 'icon icon-rubygems'
    },
    ruby: {
        icon: 'icon icon-rubygems'
    },
    yum: {
        icon: "icon icon-yum"
    },
    rpm: {
        icon: "icon icon-rpm"
    },
    debian: {
        icon: "icon icon-deb"
    },
    deb: {
        icon: "icon icon-deb"
    },
    generic: {
        icon: "icon icon-general"
    },
    build: {
        icon: "icon icon-build"
    },
    alpine: {
        icon: "icon icon-alpine"
    }
}

export function jfComponentTree() {
    return {
        scope: {
            treeDir: '=',
            parentController: '=',
            compVer: '='
        },
        controller: JfComponentTreeController,
        controllerAs: 'jfComponentTree',
        bindToController: true,
        template: `<div id="tree-element"></div>`,
        link: function ($scope) {
            $scope.jfComponentTree.initJSTree();
        }
    }
}


class JfComponentTreeController {

    constructor($q, $scope, $stateParams, $element, $timeout, ComponentsDao, JFrogEventBus, XRayUtils,
                AdvancedStringMatch, JFrogUIUtils) {

        this.$stateParams = $stateParams;

        this.$q = $q;

        this.$timeout = $timeout;

        this.$scope = $scope;

        this.componentsDao = ComponentsDao;

        this.advancedStringMatch = AdvancedStringMatch;

        this.$element = $element;

        this.xrayUtils = XRayUtils;
        this.JFrogUIUtils = JFrogUIUtils;
        this.jfrogEventBus = JFrogEventBus;
        this.EVENTS = JFrogEventBus.getEventsDefinition();

        $scope.$watch('jfComponentTree.treeDir', (oldVal, newVal) => {
            $timeout(() => {
                if (oldVal !== newVal) {
                    this.jstree().destroy();
                    this._buildTree();
                    this._registerTreeEvents();
                }
            });
        })
        this._registerEvents();

    }
    onInit(){


    }

    /****************************
     * Init code
     ****************************/

    // This is called from link function
    initJSTree() {
        this.$timeout(()=>{

            let versionOfRoot;
            if (this.parentController.$widgetObject.model.sharedData.currentVersion && this.parentController.$widgetObject.model.sharedData.currentVersion.version_number) {
                versionOfRoot = ":" + this.parentController.$widgetObject.model.sharedData.currentVersion.version_number;
            } else {
                versionOfRoot = "";

            }
            this.whenTreeDataLoaded = {}


                this.treeElement = $(this.$element).find('#tree-element');
                //            this._registerEvents();
                this._buildTree();
                this._registerTreeEvents();
        })
        // preload artifact

    }

    /****************************
     * Building the tree
     ****************************/
    _buildTree() {
        let asyncStateLoad = (obj, cb) => {
            let promise;
            if (obj.id === '#') {
                this.componentsDao.getChildren({
                    $no_spinner: true,
                    ancestors: this.treeDir === 'anc'
                }, {component_id: this.$stateParams.componentID + this.compVer}).$promise.then((children) => {

                    let versionOfRoot;
                    if (this.parentController.$widgetObject.model.sharedData.currentVersion && this.parentController.$widgetObject.model.sharedData.currentVersion.version_number) {
                        versionOfRoot = ":" + this.parentController.$widgetObject.model.sharedData.currentVersion.version_number;
                    } else {
                        versionOfRoot = "";

                    }

                    let data = [{
                        children: this._transformData(children),
                        state: {opened: true, selected: true},
                        type: this.parentController.rootComponentType,
                        text: this.JFrogUIUtils.getSafeHtml(
                            this.xrayUtils.getComponentPrettyName(this.$stateParams.componentID) + versionOfRoot),
                        data: {
                            component_id: this.$stateParams.componentID,
                            pkg_type: this.parentController.rootComponentType
                        },
                        load: () => {
                            let defer = this.$q.defer();
                            defer.resolve();
                            return defer.promise;
                        }
                    }];
                    cb(data);
                });
            }
            else {
                this.componentsDao.getChildren({
                    $no_spinner: true,
                    ancestors: this.treeDir === 'anc'
                }, {component_id: obj.data.component_id, sha256: obj.data.sha256}).$promise.then((children) => {
                    cb(this._transformData(children));
                });
            }
        };

        TreeConfig.core.data = asyncStateLoad;
        TreeConfig.contextmenu.items = this._getContextMenuItems.bind(this);
        TreeConfig.search.search_callback = this._searchCallback.bind(this);

        $(this.treeElement).jstree(TreeConfig);

    }

    _transformData(data) {
        console.log('DATA is',data)
        data = data || [];
        return data.map((node) => {
            let item = {};
            item.children = node.has_children;
            item.id = this.getUniqueId(node.component_id);//this.xrayUtils.randomString(80);
            item.text = this.JFrogUIUtils.getSafeHtml(this.xrayUtils.getComponentPrettyName(node.component_id));
            item.data = node;
            item.icon = `icon icon-${PACKAGES_ICONS[node.pkg_type.toLowerCase()].icon} seve ${this.xrayUtils.convertSeverityStatus(node.top_severity)}`
            item.type = node.pkg_type.toLowerCase();
            item.state = {opened: false};
            item.load = () => {
                let defer = this.$q.defer();
                this.componentsDao.getData({}, {
                    component_id: node.component_id
                }).$promise.then((data) => {
                    node.is_root = data.is_root;
                    node.permissions = data.permissions;
                    defer.resolve();
                })

                return defer.promise;
            }
            return item;
        });
    }

    _registerEvents() {
        this.jfrogEventBus.registerOnScope(this.$scope, this.EVENTS.TREE_SEARCH_CHANGE, text => this._searchTree(text));
        this.jfrogEventBus.registerOnScope(this.$scope, this.EVENTS.TREE_SEARCH_CANCEL, text => this._clear_search());
        this.jfrogEventBus.registerOnScope(this.$scope, this.EVENTS.TREE_SEARCH_KEYDOWN,
            key => this._searchTreeKeyDown(key));

    }

    _registerTreeEvents() {
        $(this.treeElement).on('select_node.jstree', (e, args) => {
            let data = args.node.data;
            if (data) {
                this.jfrogEventBus.dispatch(this.EVENTS.COMPONENT_SELECT, data);
                this.jstree().open_node(data.component_id);
                args.node.original.load();
            }
        });

        $(this.treeElement).scrollParent().scroll(() => this._onScroll());

    }

    jstree() {
        return $(this.treeElement).jstree();
    }

    /****************************
     * Context menu items
     ****************************/

    _getContextMenuItems(obj, cb) {

        obj.original.load().then(() => {
            let actionItems = {};
            if (obj.data.component_id !== this.$stateParams.componentID) {
                actionItems.seeRelatedComponents = {
                    label: 'View Component Details',
                    icon: 'action-icon icon icon-view',
                    action: () => {
                        this.parentController.seeRelatedComponents(obj.data.component_id);
                    }
                };
            }


            let manageable;
            if (obj.data.permissions) {
                manageable = obj.data.permissions.manageable;
            } else {
                manageable = false;
            }


            if (!obj.data.is_docker_component_layer) {

                if ((obj.data.component_id !== this.$stateParams.componentID && obj.data.is_root && obj.data.permissions.manageable) || (obj.data.component_id === this.$stateParams.componentID && this.parentController.rootIsScannable && this.parentController.manageable && !this.parentController.isDockerLater)) {
                    actionItems.manualScan = {
                        label: 'Scan for Violations', icon: 'action-icon icon icon-xray-scanning', action: () => {
                            this.parentController.manualScan(obj.data.component_id);
                        }
                    };
                }


                if (manageable || (obj.data.component_id === this.$stateParams.componentID && this.parentController.manageable && !this.parentController.isDockerLayer)) {
                    actionItems.assignCustomIssue = {
                        label: 'Assign Custom Issue',
                        icon: 'action-icon icon icon-xray-impact-analysis',
                        action: () => {

                            this.parentController.assignCustomIssue(obj.data);
                        }
                    };

                }

                if (manageable || (obj.data.component_id === this.$stateParams.componentID && this.parentController.manageable && !this.parentController.isDockerLayer)) {
                    actionItems.assignCustomLicense = {
                        label: 'Assign Custom License', icon: 'action-icon icon icon-report', action: () => {

                            let origin = 'tree';

                            if (obj.data.component_id === this.$stateParams.componentID) {
                                origin = '';
                            }
                            this.parentController.assignCustomLicense(obj.data, origin);
                        }
                    };

                }
            }


            cb(actionItems);
        });


    }


    _getSelectedTreeNode() {
        let selectedJsNode = this.jstree().get_node(this._getSelectedNode());
        return selectedJsNode && selectedJsNode.data;
    }

    _getSelectedNode() {
        return this.jstree().get_selected()[0];
    }

    _unhoverAll() {
        $('.' + JSTREE_ROW_HOVER_CLASS).removeClass(JSTREE_ROW_HOVER_CLASS);
    }

    _unhoverAll() {
        $('.' + JSTREE_ROW_HOVER_CLASS).removeClass(JSTREE_ROW_HOVER_CLASS);
    }

    _hover(domElement) {
        domElement.find('.jstree-anchor').first().addClass(JSTREE_ROW_HOVER_CLASS);
    }

    _getDomElement(node) {
        return this.jstree().get_node(node, true);
    }

    _focusOnTree() {
        // Make sure we can continue navigating the tree with the keys
        this._getSelectedJQueryElement().focus();
    }

    _getSelectedJQueryElement() {
        let nodeID = this._getSafeId(this.jstree().get_selected()[0]);
        return $('.jstree #' + nodeID + '_anchor');
    }

    _getSafeId(id) {
        return this._escapeChars(id, ["'", '=', '/', '.', ':', '$', '{', '}', '(', ')', '[', ']', '@']);
    }

    _escapeChars(str, chars) {
        let newStr = str;
        chars.forEach((char) => {
            newStr = newStr ? newStr.split(char).join('\\' + char) : newStr;
        });
        return newStr;
    }

    _scrollIntoView(domElement) {
        if (!domElement || !domElement[0]) {
            return;
        }

        /*
         if (domElement[0].scrollIntoViewIfNeeded) {
         domElement[0].scrollIntoViewIfNeeded(true);
         }
         else {
         */
        this._scrollToViewIfNeededReplacement(domElement[0], true);
        if (domElement[0].scrollIntoViewIfNeeded) {
            domElement[0].scrollIntoViewIfNeeded(true);
        }
        /*
         }
         */
    }


    _scrollToViewIfNeededReplacement(elem, centerIfNeeded, runAgain = true) {
        function withinBounds(value, min, max, extent) {
            if (false === centerIfNeeded || max <= value + extent && value <= min + extent) {
                return Math.min(max, Math.max(min, value));
            } else {
                return (min + max) / 2;
            }
        }

        function makeArea(left, top, width, height) {
            return {
                'left': left, 'top': top, 'width': width, 'height': height
                , 'right': left + width, 'bottom': top + height
                , 'translate':
                    function (x, y) {
                        return makeArea(x + left, y + top, width, height);
                    }
                , 'relativeFromTo':
                    function (lhs, rhs) {
                        var newLeft = left, newTop = top;
                        lhs = lhs.offsetParent;
                        rhs = rhs.offsetParent;
                        if (lhs === rhs) {
                            return area;
                        }
                        for (; lhs; lhs = lhs.offsetParent) {
                            newLeft += lhs.offsetLeft + lhs.clientLeft;
                            newTop += lhs.offsetTop + lhs.clientTop;
                        }
                        for (; rhs; rhs = rhs.offsetParent) {
                            newLeft -= rhs.offsetLeft + rhs.clientLeft;
                            newTop -= rhs.offsetTop + rhs.clientTop;
                        }
                        return makeArea(newLeft, newTop, width, height);
                    }
            };
        }

        var parent, area = makeArea(
            elem.offsetLeft, elem.offsetTop,
            elem.offsetWidth, elem.offsetHeight);
        while ((parent = elem.parentNode) instanceof HTMLElement) {
            var clientLeft = parent.offsetLeft + parent.clientLeft;
            var clientTop = parent.offsetTop + parent.clientTop;

            // Make area relative to parent's client area.
            area = area.relativeFromTo(elem, parent).translate(-clientLeft, -clientTop);

            parent.scrollLeft = withinBounds(
                parent.scrollLeft,
                area.right - parent.clientWidth, area.left,
                parent.clientWidth);

            parent.scrollTop = withinBounds(
                parent.scrollTop,
                area.bottom - parent.clientHeight, area.top,
                parent.clientHeight);

            // Determine actual scroll amount by reading back scroll properties.
            area = area.translate(clientLeft - parent.scrollLeft,
                clientTop - parent.scrollTop);
            elem = parent;
        }

        if (runAgain) {
            this._scrollToViewIfNeededReplacement(elem, centerIfNeeded, false);
        } //hackish fix

    }


    /************************************************************************************************************************************
     * New Advanced Quick Find !!
     ************************************************************************************************************************************/

    /********************************************
     * Is the node matching the search criteria
     ********************************************/
    _searchCallback(str, jsTreeNode, elem) {
        if (jsTreeNode.parent === '#' && jsTreeNode.text === '..' && jsTreeNode.type === 'go_up') {
            return true;
        }
        if (!jsTreeNode.data) {
            return false;
        }
        let treeNode = jsTreeNode.data;
        // Special filters:
        /*
                let filterRegexp = new RegExp(REGEXP);
                let matches = filterRegexp.exec(str);
                if (matches && matches[2].trim()) {
                    let filterType = matches[1];
                    let filterText = matches[2];
                    let rootRepo = this._getRootRepo(jsTreeNode).data;

                    switch(filterType) {
                        case 'pkg':
                            return ((treeNode.isRepo() && treeNode.repoPkgType && treeNode.repoPkgType.toLowerCase().indexOf(filterText.toLowerCase()) != -1) || (!treeNode.isRepo() && this.activeFilter && (rootRepo.isRepo() && rootRepo.repoPkgType.toLowerCase().indexOf(filterText.toLowerCase()) != -1)) || (((treeNode.isTrashcan && treeNode.isTrashcan()) || (treeNode.isInTrashcan && treeNode.isInTrashcan())) && localStorage.pinnedTrash && this.type === 'tree'));
                        case 'repo':
                            return ((treeNode.isRepo() && treeNode.repoType.toLowerCase().indexOf(filterText.toLowerCase()) != -1) || (!treeNode.isRepo() && this.activeFilter && (rootRepo.isRepo() && rootRepo.repoType.toLowerCase().indexOf(filterText.toLowerCase()) != -1)) || (((treeNode.isTrashcan && treeNode.isTrashcan()) || (treeNode.isInTrashcan && treeNode.isInTrashcan())) && localStorage.pinnedTrash && this.type === 'tree'));
                    }
                }
        */
        // Regular text search:
        //        else {
        //            if (!this._isVisible(jsTreeNode)) return false;

        let matchObj = this.advancedStringMatch.match(this.xrayUtils.getComponentPrettyName(treeNode.component_id),
            str);
        if (elem) {
            if (matchObj.matched) {
                $(elem).prop('segments', matchObj.segments);
            } else {
                $(elem).prop('segments', null);
            }
        }
        return matchObj.matched;
        //        }

    }

    /****************************
     * Searching the tree
     ****************************/
    _searchTree(text, gotoFirst = true, showSpinner = true) {
        this.searchText = text || '';
        let showOnlyMatches = false;//text ? text.match(new RegExp(REGEXP)) || false : false;
        this._jsQuickFind(this.searchText, showOnlyMatches, gotoFirst, showSpinner);
    }

    _cancelRunningSearch() {
        if (this.searchTimeoutPromise) {
            this.$timeout.cancel(this.searchTimeoutPromise);
            this.searchTimeoutPromise = null;
            this.jfrogEventBus.dispatch(this.EVENTS.TREE_SEARCH_RUNNING, false);
        }
    }

    _jsQuickFind(searchText, showOnlyMatches, gotoFirst = true, showSpinner = true) {
        this._cancelRunningSearch();
        if (!searchText || this._isInActiveFilterMode() === 'empty') {
            this._clear_search();
            return;
        }
        let res = [];
        let nodes = [];
        let nodesParents = [];
        let nomatches = [];
        let nomatchesParents = [];
        var all = $('.jstree-anchor');

        let i = 0;
        let doIteration = () => {
            let startI = i;
            while (i < startI + 500 && i < all.length) {
                let e = $(all[i]);
                if (searchText && e.text()) {
                    let id = e.prop('id');
                    id = id.substr(0, id.length - '_anchor'.length);
                    let treeNode = this.jstree().get_node(id);
                    if (this._searchCallback(searchText, treeNode, e[0])) {
                        let goneToFirst = false;
                        if (gotoFirst && !nodes.length) { //goto first result
                            goneToFirst = true;
                            this.searchResults = [id];
                            this._initCurrentSearchResult([e[0]]);
                            this._gotoCurrentSearchResult();
                        }
                        res.push(id);
                        nodes.push(e[0]);
                        nodesParents.push(e[0].parentElement);


                        if ((goneToFirst || this._isScrolledIntoView(e[0], 0)) && !showOnlyMatches) {
                            e.addClass('jstree-search');
                            let jqe = $(e[0]);
                            jqe.unhighlight();
                            let segs = jqe.prop('segments');
                            if (segs) {
                                this.advancedStringMatch.highlight(jqe, segs);
                            }
                        }
                        else if (showOnlyMatches) {
                            //                            e.addClass('jstree-search');
                        }
                    }
                    else {
                        nomatches.push(e[0]);
                        nomatchesParents.push(e[0].parentElement);
                        if (this._isScrolledIntoView(e[0], 0) && !showOnlyMatches) {
                            e.removeClass('jstree-search');
                            $(e[0]).unhighlight();
                        }
                        else if (showOnlyMatches) {
                            //                            e.removeClass('jstree-search');
                        }
                    }
                }
                else {
                    nomatches.push(e[0]);
                    nomatchesParents.push(e[0].parentElement);
                    if (this._isScrolledIntoView(e[0], 0) && !showOnlyMatches) {
                        e.removeClass('jstree-search');
                        $(e[0]).unhighlight();
                    }
                    else if (showOnlyMatches) {
                        //                        e.removeClass('jstree-search');
                    }
                }
                i++;
                this.searchResults = res;
                this.searchNodes = nodes;
                this.searchParentNodes = nodes;
                this.nomatchNodes = nomatches;
                this.nomatchParentNodes = nomatchesParents;
            }

        };

        let timeOutFunc = () => {
            if (i < all.length) {
                if (showSpinner && i === 0 && all.length > 250) {
                    this.jfrogEventBus.dispatch(
                        this.EVENTS.TREE_SEARCH_RUNNING, true);
                }
                doIteration();
                this.searchTimeoutPromise = this.$timeout(() => timeOutFunc());
            }
            else { // finish

                this.searchTimeoutPromise = null;
                if (showOnlyMatches && res.length) {
                    $('.hidden:has(".jstree-anchor")').removeClass('hidden');
                    $(this.searchParentNodes).removeClass('hidden');
                    $(this.nomatchParentNodes).addClass('hidden');
                }
                else {
                    $('.hidden:has(".jstree-anchor")').removeClass('hidden');
                }

                this.jfrogEventBus.dispatch(this.EVENTS.TREE_SEARCH_RUNNING, false);
            }
        };
        this.searchTimeoutPromise = this.$timeout(() => timeOutFunc());

    }

    _onScroll() {
        if (!this.searchNodes || this._isInActiveFilterMode()) {
            return;
        }
        for (let i = 0; i < this.searchNodes.length; i++) {
            if (this._isScrolledIntoView(this.searchNodes[i], 0)) {
                let jqe = $(this.searchNodes[i]);
                jqe.addClass('jstree-search');
                jqe.unhighlight();
                let segs = jqe.prop('segments');
                if (segs) {
                    this.advancedStringMatch.highlight(jqe, segs);
                }
            }
        }
        for (let i = 0; i < this.nomatchNodes.length; i++) {
            if (this._isScrolledIntoView(this.nomatchNodes[i], 0)) {
                let jqe = $(this.nomatchNodes[i]);
                jqe.removeClass('jstree-search');
                jqe.unhighlight();
            }
        }
    }


    _isScrolledIntoView(el, marginSize = 0) {
        let elemTop = el.getBoundingClientRect().top;
        let elemBottom = el.getBoundingClientRect().bottom;

        var isVisible = (elemTop >= -marginSize) && (elemBottom <= window.innerHeight + marginSize);
        return isVisible;
    }

    _initCurrentSearchResult(nodes) {
        if (!this.currentResult || !_.includes(this.searchResults, this.currentResult)) {
            // there is no previous result, or previous result is not included in the search results
            // select first result that's below the node we started the search from
            let startFromDom = this.jstree().get_node(this._getSelectedNode(), /* as_dom = */ true)[0];
            let firstNodeBelow = _.find(nodes, (node) => {
                if (!startFromDom) {
                    return true;
                }
                return node.offsetTop > startFromDom.offsetTop;
            });
            // if found - select as first result, if not - select first search result
            this.currentResult = firstNodeBelow ? firstNodeBelow.id.substr(
                0, firstNodeBelow.id.length - '_anchor'.length) : this.searchResults[0];
        }
    }

    _isInActiveFilterMode(checkIfMatchesFound = false) {
        return false;
        /*
                if (this.searchText.match(new RegExp(REGEXP))) {
                    let justSearchTerm = this.searchText.substr(this.searchText.indexOf(':')+1).trim();
                    if (justSearchTerm) {
                        if (checkIfMatchesFound) {
                            let json = this.jstree().get_json();
                            let matchesFound = false;
                            for (let node of json) {
                                node.data.isRepo = () => {
                                    return node.data.type === 'repository' ||
                                        node.data.type === 'virtualRemoteRepository' ||
                                        node.data.type === 'localRepository' ||
                                        node.data.type === 'remoteRepository' ||
                                        node.data.type === 'cachedRepository' ||
                                        node.data.type === 'virtualRepository';
                                };
                                if (this._searchCallback(this.searchText,node)) {
                                    matchesFound = true;
                                    break;
                                }
                            }
                            return matchesFound ? true : 'no results';
                        }
                        else {
                            return true;
                        }
                    }
                    else return 'empty';
                }
                else return false;
        */
    }

    _searchTreeKeyDown(key) {
        let jstree = this.jstree();
        if (key == KEYS.DOWN_ARROW) {
            this._selectNextSearchResult();
        }
        else if (key == KEYS.UP_ARROW) {
            this._selectPreviousSearchResult();
        }
        else if (key == KEYS.ENTER) {
            //manually set the model to the input element's value (because the model is debounced...)
            this.searchText = $('.jf-tree-search').val();

            let isInActiveFilterMode = this._isInActiveFilterMode(true);

            if (isInActiveFilterMode === true) {
                this.activeFilter = true;
                if (this.browserController) {
                    this.browserController.activeFilter = true;
                    this.browserController.searchText = this.searchText + '*';
                }
                this._searchTree(this.searchText);
                this._focusOnTree();
                if (!this._isVisible(jstree.get_node(this._getSelectedNode()))) {
                    jstree.select_node(this._getFirstVisibleNode());
                }
            }
            else if (isInActiveFilterMode === 'no results') {
                if (this.artifactoryNotifications) {
                    this.artifactoryNotifications.create({
                        warn: 'No repositories matches the filtered ' + (this.searchText.startsWith(
                            'pkg:') ? 'package' : 'repository') + ' type'
                    });
                }
            }
            else {
                this.activeFilter = false;
                if (this.browserController) {
                    this.browserController.activeFilter = false;
                }
                this._selectCurrentSearchResult();
                jstree.open_node(this.currentResult);
                this._clear_search();
                this._focusOnTree();
                this.currentResult = null;
            }
        }
        else if (key == KEYS.ESC) {
            this.activeFilter = false;
            if (this.browserController) {
                this.browserController.activeFilter = false;
            }
            this._clear_search();
            this._focusOnTree();
            this.currentResult = null;
        }
        else {
            this.$timeout(() => {
                this.searchText = $('.jf-tree-search').val();
                if (this.searchText === '') {
                    $(this.treeElement).unhighlight();
                }
            })
        }
    }

    _clear_search() {
        this._cancelRunningSearch();
        this.activeFilter = false;
        if (this.browserController) {
            this.browserController.activeFilter = false;
        }
        this._unhoverAll();
        this.jstree().clear_search();
        $('.hidden:has(".jstree-anchor")').removeClass('hidden');
        $('.jstree-anchor.jstree-search').removeClass('jstree-search');
        $(this.treeElement).unhighlight();
        this.searchNodes = null;
        this.searchParentNodes = null;
        this.nomatchNodes = null;
        this.nomatchParentNodes = null;
        this.searchText = '';
    }

    _selectNextSearchResult() {
        let index = this.searchResults.indexOf(this.currentResult);
        index++;
        if (index > this.searchResults.length - 1) {
            index = 0;
        }
        this.currentResult = this.searchResults[index];
        this._gotoCurrentSearchResult();
    }

    _selectPreviousSearchResult() {
        let index = this.searchResults.indexOf(this.currentResult);
        index--;
        if (index < 0) {
            index = this.searchResults.length - 1;
        }
        this.currentResult = this.searchResults[index];
        this._gotoCurrentSearchResult();
    }

    _gotoCurrentSearchResult() {
        this._unhoverAll();
        if (this.currentResult) {
            let domElement = this._getDomElement(this.currentResult);
            this._hover(domElement);
            this._scrollIntoView(domElement);
        }
    }

    _selectCurrentSearchResult() {
        if (this.currentResult) {
            this.jstree().deselect_all();
            this.jstree().select_node(this.currentResult);
        }
    }

    getUniqueId(id) {
        let exists = $('#' + this._getSafeId(id));
        if (exists.length) {
            return this.getUniqueId(id + '[' + this.xrayUtils.randomString(10) + ']');
        }
        else {
            return id;
        }
    }

}




// WEBPACK FOOTER //
// ./modules/xray/directives/jf_component_tree/jf_component_tree.js